import React, { useState } from "react";
import { Lock, Eye, EyeOff, Settings } from "lucide-react";
import TopBar from "../components/TopBar";
import './css/Accounts.css';
import axios from "./../axios";
import toast from 'react-hot-toast';

const Account = ({ setSideBar, setSettingDrawer }) => {
  const [student, setStudent] = useState(JSON.parse(localStorage.getItem('student')));
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showOldPassword, setShowOldPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");

    if (!oldPassword || !newPassword || !confirmPassword) {
      setError("All fields are required.");
      toast.error("All fields are required.");
      return;
    }
// console.log(student);
//     if (oldPassword !== student?.password) {
//       setError("Old password is incorrect.");
//       toast.error("Old password is incorrect.");
//       return;
//     }

    if (newPassword !== confirmPassword) {
      setError("New password and confirm password do not match.");
      toast.error("New password and confirm password do not match.");
      return;
    }
    if (newPassword.length < 5) {
      setError("New password must be at least 5 characters long.");
      toast.error("New password must be at least 5 characters long.");
      return;
    }

    try {
      const token = localStorage.getItem("student_token");
      const response =  await axios.get('student/reset_password', {
        headers: { Authorization: `Bearer ${token}` },
        params: {
          old_password: oldPassword,
          new_password: newPassword,
          confirm_password: confirmPassword
        }
      });
      console.log(response.data);

      // Update student in localStorage with new password
      const updatedStudent = { ...student, password: newPassword };
      localStorage.setItem('student', JSON.stringify(updatedStudent));
      setStudent(updatedStudent);

      setSuccess("Password changed successfully!");
      toast.success("Password changed successfully!");
      // setOldPassword("");
      // setNewPassword("");
      // setConfirmPassword("");
    } catch (error) {
      setError("Failed to change password. Please try again.");
      toast.error("Failed to change password. Please try again.");
      console.error("Password change error:", error);
    }
  };

  return (
    <>
      <TopBar title="Accounts" setSideBar={setSideBar} setSettingDrawer={setSettingDrawer} />
      <div className="accounts-container">
        <div className="form-header">
          <Settings size={20} className="header-icon" />
          <h2>Change Password</h2>
        </div>
        <form className="password-form" onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="old-password">Old Password</label>
            <div className="input-wrapper">
              <Lock size={18} className="input-icon" />
              <input
                type={showOldPassword ? "text" : "password"}
                id="old-password"
                value={oldPassword}
                onChange={(e) => setOldPassword(e.target.value)}
                placeholder="Enter old password"
              />
              <button
                type="button"
                className="toggle-password"
                onClick={() => setShowOldPassword(!showOldPassword)}
              >
                {showOldPassword ? <EyeOff size={18} /> : <Eye size={18} />}
              </button>
            </div>
          </div>
          <div className="form-group">
            <label htmlFor="new-password">New Password</label>
            <div className="input-wrapper">
              <Lock size={18} className="input-icon" />
              <input
                type={showNewPassword ? "text" : "password"}
                id="new-password"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                placeholder="Enter new password"
              />
              <button
                type="button"
                className="toggle-password"
                onClick={() => setShowNewPassword(!showNewPassword)}
              >
                {showNewPassword ? <EyeOff size={18} /> : <Eye size={18} />}
              </button>
            </div>
          </div>
          <div className="form-group">
            <label htmlFor="confirm-password">Confirm New Password</label>
            <div className="input-wrapper">
              <Lock size={18} className="input-icon" />
              <input
                type={showConfirmPassword ? "text" : "password"}
                id="confirm-password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                placeholder="Confirm new password"
              />
              <button
                type="button"
                className="toggle-password"
                onClick={() => setShowConfirmPassword(!showConfirmPassword)}
              >
                {showConfirmPassword ? <EyeOff size={18} /> : <Eye size={18} />}
              </button>
            </div>
          </div>
          {error && <div className="error-message">{error}</div>}
          {success && <div className="success-message">{success}</div>}
          <button type="submit" className="submit-button">
            Update Password
          </button>
        </form>
      </div>
    </>
  );
};

export default Account;